import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import homepageLogo from '../../../../assets/images/homepage-logo.png'

const mainColor = '#02489D';

interface TeamVehicleMarkerProps {
    lat: number,
    lng: number
};

const useStyles = makeStyles((theme) => ({
    makerWrapper: {
        width: 56,
        height: 56,
        borderRadius: 56,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        cursor: "pointer",
        transform: "translate(-50%, -50%)",
        backgroundColor: `${mainColor}50`
    },
    markRect: {
        position: "absolute",
        left: 62,
        width: 191,
        height: 43,
        borderRadius: 11,
        display: "flex",
        justifyContent: "center",
        backgroundColor: mainColor
    },
    markArrow: {
        position: "absolute",
        left: 39,
        width: 0,
        height: 0,
        borderRight:`30px solid ${mainColor}`,
        borderBottom:'10px solid transparent',
        borderTop: '10px solid transparent'
    },
    markContainer: {
        width: 13,
        height: 13,
        borderRadius: 13,
        backgroundColor: mainColor
    },
    logo: {
        width: 161,
        height: 28,
        margin: '9px 15px 6px 15px'
    },
}));

const TeamVehicleMarker: React.FC<TeamVehicleMarkerProps> = () => {
    const classes = useStyles();
    return (
        <div className={classes.makerWrapper}>
            <div className={classes.markContainer}></div>
            <div className={classes.markArrow} ></div>
            <div className={classes.markRect}>
                <img src={homepageLogo} className={classes.logo} />
            </div>
        </div>
    );
};

export default TeamVehicleMarker;